import { useDispatch, useSelector } from 'react-redux';
import { setActiveDashboardId } from '@store/dashboards/ui/actions';
import getActualShareLink from '@components/common/Sharing/SharingModal/SharingContent/getActualShareLink';
import {
  setDefaultLandingPage,
  setDefaultLandingPagePromptContent,
  setDefaultLandingPagePromptNeedInput,
  setDefaultLandingPagePromptOkFn,
  setDefaultLandingPagePromptTitle,
  showPrompt,
} from '@store/defaultLandingPage/actions';
import commonSelector from '@store/common/selectors';
import { selector as defaultLandingPageSelector } from '@store/defaultLandingPage';

export function useDefaultHandler() {
  const dispatch = useDispatch();
  const { profiles } = useSelector(commonSelector);
  const defaultLandingPage = useSelector(defaultLandingPageSelector);
  const cid = profiles.filter((p) => p.is_selected)[0].customer_id;
  const onSetDefaultLandingApply = () => {
    const { pathname } = window.location;
    dispatch(setActiveDashboardId(null));
    const arr = pathname.split('/');
    const u = getActualShareLink(pathname, cid);
    dispatch(
      setDefaultLandingPage({
        url: u,
        name: arr[arr.length - 1],
        path: pathname,
      }),
    );
  };

  const hasDefaultLandingPage = defaultLandingPage.url.length > 0;
  const dlpTitle = 'Make default';
  const dlpNeedInput = false;
  const dlpContent = hasDefaultLandingPage
    ? 'Are you sure you want to change your default dashboard?'
    : 'Are you sure you want to set your default dashboard?';
  const dlpOkFn = () => onSetDefaultLandingApply();

  const onSetDefaultLanding = () => {
    dispatch(setActiveDashboardId(null));
    dispatch(setDefaultLandingPagePromptNeedInput(dlpNeedInput));
    dispatch(setDefaultLandingPagePromptTitle(dlpTitle));
    dispatch(setDefaultLandingPagePromptContent(dlpContent));
    dispatch(setDefaultLandingPagePromptOkFn(dlpOkFn));
    dispatch(showPrompt());
  };
  return {
    onSetDefaultLanding,
    dlpTitle,
    dlpNeedInput,
    dlpContent,
    dlpOkFn,
  };
}
